import { Node, mergeAttributes, PasteRule } from '@tiptap/core'

export const CommentLink = Node.create({
  name: 'commentLink',
  group: 'inline',
  inline: true,
  selectable: true,
  atom: true,

  addAttributes() {
    return {
      commentId: {
        default: null,
        parseHTML: element => element.getAttribute('commentid'),
        renderHTML: attributes => {
          if (!attributes.commentId) return {}
          return { 'commentid': attributes.commentId }
        }
      },
      commentTitle: {
        default: 'Комментарий',
        parseHTML: element => element.getAttribute('commenttitle') || element.textContent,
        renderHTML: attributes => {
          if (!attributes.commentTitle) return {}
          return { 'commenttitle': attributes.commentTitle }
        }
      },
      entryUrl: {
        default: '',
        parseHTML: element => element.getAttribute('entryurl'),
        renderHTML: attributes => {
          if (!attributes.entryUrl) return {}
          return { 'entryurl': attributes.entryUrl }
        }
      }
    }
  },

  parseHTML() {
    return [
      { tag: 'span.tiptap-comment-link' }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    let stimulusAttributes  = {
      'data-controller': 'comment-link',
      'data-comment-link-url-value': HTMLAttributes['entryurl'],
      'class': 'tiptap-comment-link'
    }

    if (HTMLAttributes['commentid']) {
      stimulusAttributes['data-comment-link-id-value'] = HTMLAttributes['commentid']
      stimulusAttributes['data-action'] = 'click->comment-link#goToComment'
    } else {
      stimulusAttributes['data-action'] = 'click->comment-link#goToEntry'
    }

    return [
      'span',
      mergeAttributes(HTMLAttributes, stimulusAttributes),
      `${HTMLAttributes['commenttitle']}`
    ]
  },

  addPasteRules() {
    return [
      new PasteRule({
        find: /https?:\/\/[^\s]+?\/entries\/([^\s#]+)#event_(\d+)/g,
        handler: ({ match, range, state }) => {
          const entryId = match[1]
          const commentId = match[2]
          const fullUrl = match[0]

          if (!commentId) return

          const node = state.schema.nodes[this.name].create({
            commentId: commentId,
            entryUrl: fullUrl,
            commentTitle: `!${entryId} (Комментарий #${commentId})`
          })

          state.tr.replaceWith(range.from, range.to, node)
        },
      }),

      new PasteRule({
        find: /https?:\/\/[^\s/$.?#].[^\s]*?\/entries\/([a-zA-Z0-9_-]+)(?=[?\s]|$)/g,
        handler: ({ match, range, state }) => {
          const entryId = match[1]
          const fullUrl = match[0]

          const node = state.schema.nodes[this.name].create({
            commentId: null,
            entryUrl: fullUrl,
            commentTitle: `!${entryId}`
          })

          state.tr.replaceWith(range.from, range.to, node)
        },
      }),
    ]
  },
})
